<template>
  <div>
    <news-details :news_id="Number($route.params.news)" />
    <div class="container">
      <div class="hero">
        <div class="columns is-mobile">
          <div class="column is-4">
            <router-link :to="{name: 'New', query:{ mode: 1 }}">
              <button class="button is-rounded is-pulled-right is-info">編集</button>
            </router-link>
          </div>
          <div class="column is-4">
            <router-link :to="{name: 'New', query:{ mode: 2 }}">
              <button class="button is-rounded is-warning">引用</button>
            </router-link>
          </div>
          <div class="column is-4">
            <button class="button is-rounded is-pulled-left is-danger" @click="onDelete">削除</button>
          </div>
        </div>
      </div>
    </div>
    <section class="section">
      <div class="hero">
        <div class="field">
          <button class="button is-link is-size-5 is-rounded" @click="$router.go(-1)">戻る</button>
        </div>
      </div>
    </section>
    <section class="hero is-danger">
      <h3 class="is-size-3">乗務員履歴</h3>
    </section>
    <section class="section">
      <div class="container" style="width: calc(55% - 100px);">
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>ID</th>
              <th>乗務員名</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in getItems" v-bind:key="item.id">
              <template v-if="item.done != 1">
                <td>{{ item.login_id }}</td>
                <td>{{ item.username }}</td>
                <td class="has-text-danger">{{ item.done === "1" ? "確認済み" : "" }}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import NewsDetails from "../../../components/NewsDetails.vue";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    "news-details": NewsDetails,
  },
  mounted() {
    this.$store.dispatch("news/getArticleUser", null);
  },
  computed: {
    ...mapGetters({
      readUsers: "news/readUsers",
    }),
    getItems() {
      return this.readUsers(this.$route.params.news);
    },
    ...mapState({
      apiStatus: (state) => state.news.apiStatus,
    }),
  },
  methods: {
    async onDelete() {
      if (
        !confirm(
          "表示しているお知らせを削除してよろしいですか？\n※削除した記事の復元はできません。"
        )
      )
        return false;
      await this.$store.dispatch("news/deleteNews", {
        news_id: this.$route.params.news,
      });
      if (this.apiStatus) {
        alert("お知らせを削除しました");
        this.$router.replace("/"); //戻る処理の対応
        this.$router.push({ name: "LogsList" });
      }
    },
  },
};
</script>

<style scoped>
.container {
  text-align: center;
}
/* button {
    min-width: calc(50% - 100px);
    margin: 12px 12px;
  } */
.hero {
  text-align: center;
}
</style>
